import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

function getSystemTheme(): Theme {
  const isDarkSystemTheme =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  return isDarkSystemTheme ? "dark" : "light";
}

type Theme = "dark" | "light";

interface ThemeStore {
  theme?: Theme;
  setSystemTheme: () => void;
  setTheme: (theme?: Theme) => void;
}

function setHTMLTheme(theme: Theme) {
  const element = document.querySelector("html");
  if (!element) {
    return;
  }
  element.classList.remove("light", "dark");
  element.classList.add(theme);
  element.style.colorScheme = theme;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      setSystemTheme() {
        const theme = getSystemTheme();
        setHTMLTheme(theme);

        set({ theme: theme });
      },
      setTheme(newTheme) {
        const { setSystemTheme, theme } = get();

        if (newTheme) {
          setHTMLTheme(newTheme);
          set({ theme: newTheme });
          return;
        }

        if (theme) {
          setHTMLTheme(theme);
          return;
        }

        setSystemTheme();
      },
    }),
    {
      name: `prelude:theme`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
